import {gql} from '@apollo/client'

export const PARENTAL_LEAVE_SUPPORT_ALLOWANCE_REQUEST = gql`
  query parentalLeaveSupportAllowanceRequest($employeeId: ID!) {
    client {
      employee(employeeId: $employeeId) {
        id
        staffCode
        displayFullName
        user {
          id
          email
        }
      }
    }
  }
`

export interface ParentalLeaveSupportAllowanceRequestQueryVariables {
  employeeId: string
}

export interface ParentalLeaveSupportAllowanceRequestQueryResult {
  client: {
    employee: Employee
  }
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
  user?: {
    id: string
    email: string
  }
}
